import { useEffect, useState } from 'react';
import { Zap } from 'lucide-react';

interface XpFlashProps {
  amount: number;
  trigger: number; // increment to trigger animation
}

export function XpFlashToast({ amount, trigger }: XpFlashProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (trigger === 0) return;
    setVisible(true);
    const timer = setTimeout(() => setVisible(false), 2000);
    return () => clearTimeout(timer);
  }, [trigger]);

  if (!visible) return null;

  return (
    <div className="fixed bottom-6 left-1/2 z-[100] -translate-x-1/2 animate-xp-flash pointer-events-none">
      <div className="flex items-center gap-2 rounded-2xl border border-yellow-500/30 bg-gradient-to-r from-yellow-500/90 to-amber-500/90 px-5 py-3 shadow-2xl backdrop-blur">
        <Zap className="h-5 w-5 text-white animate-pulse" />
        <span className="text-sm font-bold text-white">+{amount} XP</span>
      </div>
    </div>
  );
}

/** Global XP event system */
const XP_KEY = 'mw-session-xp';

export function getSessionXp(): number {
  try {
    const raw = sessionStorage.getItem(XP_KEY);
    return raw ? parseInt(raw, 10) : 0;
  } catch {
    return 0;
  }
}

export function addSessionXp(amount: number): number {
  const current = getSessionXp();
  const next = current + amount;
  sessionStorage.setItem(XP_KEY, String(next));
  window.dispatchEvent(new CustomEvent('xp-earned', { detail: { amount, total: next } }));
  return next;
}
